module.exports = __webpack_public_path__ + "img/strategy_icon1.386857a4-6d613ebe.1c1cd6ae.svg";